// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const WrapperHeader = styled.div<{ isDark: boolean; height?: string }>(
  ({ theme, isDark, height }) => css`
    width: 100%;
    height: ${height || '64px'};
    min-height: '64px';
    position: relative;
    display: flex;
    align-items: center;
    background-color: ${
      isDark ? theme.colors.base['light-dark-mode'] : theme.colors.white
    };
    box-shadow: 0px -4px 18px rgba(135, 143, 184, 0.12);
    transition: all 0.5s ease 0s;
  `,
);

export const WrapperActions = styled.div`
  position: absolute;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 22px;
`;

export const BackButton = styled.a<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 100%;
    border-right: 1px solid ${theme.colors.gray['dark-24']};
    cursor: pointer;
    :hover {
      background-color: ${
        isDark ? theme.colors.base.main : theme.colors.gray.light
      };
    }
  `,
);

export const HelpWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
`;

export const BeautyButton = styled.div<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    align-items: center;
    color: ${isDark ? theme.colors.secondary.main : theme.colors.primary.main};
    cursor: pointer;

    :hover {
      color: ${
        isDark ? theme.colors.secondary.light : theme.colors.primary.lighter
      };
    }
  `,
);

export const WrapperLogo = styled.div(
  ({ theme }) => css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    ${theme.breakpoints.down('sm')} {
      display: none;
    }

    /*
    * Prefixed by https://autoprefixer.github.io
    * PostCSS: v8.4.14,
    * Autoprefixer: v10.4.7
    * Browsers: last 4 version
    */

    @-webkit-keyframes inAnimation {
      0% {
        opacity: 0;
        display: none;
      }
      100% {
        opacity: 1;
        display: -webkit-box;
        display: flex;
      }
    }

    @keyframes inAnimation {
      0% {
        opacity: 0;
        display: none;
      }
      100% {
        opacity: 1;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
    }

    @-webkit-keyframes outAnimation {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0;
        display: none;
      }
    }

    @keyframes outAnimation {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0;
        display: none;
      }
    }
  `,
);
